import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionHeading } from "../components/Reveal";
import { PROTOCOLS } from "../lib/protocols";

function FeatureCard({ p }) {
  return (
    <Link
      to={`/protocollo/${p.slug}`}
      data-testid={`protocol-card-${p.slug}`}
      className="card-hub group relative flex min-h-[340px] flex-col justify-end overflow-hidden p-8 md:col-span-4 md:p-10"
    >
      <img
        src={p.heroImage}
        alt={p.name}
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover opacity-40"
        style={{ filter: "grayscale(0.6) brightness(0.5)" }}
      />
      <div
        className="absolute inset-0"
        style={{ background: "linear-gradient(0deg, #0b0b0b 22%, rgba(11,11,11,0.55) 60%, rgba(11,11,11,0.25))" }}
      />
      <div className="relative">
        <span className="font-mono text-[11px] tracking-[0.16em] text-gold">{p.number}</span>
        <h3 className="display mt-5 text-3xl text-cream sm:text-4xl">{p.name}</h3>
        <p className="mt-2 text-[13px] font-semibold uppercase tracking-[0.14em] text-gold-light">{p.tagline}</p>
        <p className="mt-4 max-w-[420px] text-[14px] leading-relaxed text-[#c9c6bf]">{p.shortCopy}</p>
        <span className="mt-6 inline-flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.2em] text-cream transition-colors group-hover:text-gold-light">
          Scopri il protocollo
          <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
        </span>
      </div>
    </Link>
  );
}

function SmallCard({ p }) {
  return (
    <Link
      to={`/protocollo/${p.slug}`}
      data-testid={`protocol-card-${p.slug}`}
      className="card-hub group relative flex min-h-[340px] flex-col justify-between overflow-hidden p-7 md:col-span-2"
    >
      <img
        src={p.heroImage}
        alt={p.name}
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover opacity-60 transition-all duration-700 group-hover:scale-[1.04] group-hover:opacity-75"
        style={{ filter: "grayscale(0.5) brightness(0.68)" }}
      />
      <div
        className="absolute inset-0"
        style={{ background: "linear-gradient(0deg, #0b0b0b 12%, rgba(11,11,11,0.42) 58%, rgba(11,11,11,0.12))" }}
      />
      <div className="relative flex items-start justify-between">
        <span className="font-mono text-[11px] tracking-[0.16em] text-gold">{p.number}</span>
        <ArrowUpRight size={16} className="text-[#929292] transition-all duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-gold-light" />
      </div>
      <div className="relative">
        <h3 className="display text-[26px] leading-tight text-cream">{p.name}</h3>
        <p className="mt-2 text-[11px] font-semibold uppercase tracking-[0.13em] text-gold-light">{p.tagline}</p>
        <p className="mt-3 text-[13px] leading-relaxed text-[#c9c6bf]">{p.shortCopy}</p>
      </div>
    </Link>
  );
}

export default function ProtocolliSection() {
  return (
    <section id="protocolli" className="section" data-testid="protocolli-section">
      <div className="container-hub">
        <SectionHeading
          eyebrow="I 5 protocolli"
          title={<>CINQUE PERCORSI PROPRIETARI. <span className="gold-text">ZERO IMPROVVISAZIONE.</span></>}
          lead="Ogni obiettivo ha un protocollo dedicato, con fasi, controlli e responsabilità definite. Clicca su un protocollo per scoprire tutto quello che include."
        />
        <div className="mt-14 grid grid-cols-1 gap-4 md:grid-cols-6 lg:gap-5">
          <Reveal className="md:col-span-4" delay={0.05}>
            <FeatureCard p={PROTOCOLS[0]} />
          </Reveal>
          <Reveal className="md:col-span-2" delay={0.12}>
            <SmallCard p={PROTOCOLS[1]} />
          </Reveal>
          <Reveal className="md:col-span-2" delay={0.19}>
            <SmallCard p={PROTOCOLS[2]} />
          </Reveal>
          <Reveal className="md:col-span-2" delay={0.26}>
            <SmallCard p={PROTOCOLS[3]} />
          </Reveal>
          <Reveal className="md:col-span-2" delay={0.33}>
            <SmallCard p={PROTOCOLS[4]} />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
